import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { startLoading, doneLoading } from '../../../utils/loading'
import { getSchemaSidebar } from '../../../redux/actions/sidebar'
import InputDataTableForm from '../../../components/forms/input/InputDataTableForm'
import InputDataTableView from '../../../components/forms/input/InputDataTableView'
import * as ExpectedResultApi from '../../../redux/actions/ProjectExpectedResult'

export default function ExpectedResultView(props) {
  const { showCommandButton, isEditAll } = props
  const [isEdit, setIsEdit] = useState(props.isEditAll)
  const [isError, setIsError] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    setIsEdit(isEditAll)
    setIsError(false)
  }, [isEditAll])

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)

    try {
      const saveData = {
        id: request.data.id,
        projectVersionId: projectId,
        userId: '111',
        value: request.data.value,
      }

      let response
      if (request.data.id) {
        console.log('call update.')
        response = await ExpectedResultApi.updateBenefit(projectId, saveData)
      } else {
        console.log('call save.')
        response = await ExpectedResultApi.saveBenefit(projectId, saveData)
      }

      if (response) {
        setFormSchema(response.expectedWay)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDelete = async (schema) => {
    startLoading()
    setIsLoading(true)
    setIsDeleteError(false)
    try {
      console.log('call delete.')
      const status = await ExpectedResultApi.deleteBenefit(projectId, schema.id)
      if (status === 200) {
        console.log('call get.')
        const _schema = await ExpectedResultApi.getProjectExpectedResult(projectId)

        setFormSchema(_schema.forms.expectedResult.expectedWay)
      } else {
        setIsDeleteError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsDeleteError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    let dataList = [...formSchema.value]
    let id = ''
    if (data.selectedIndex != -1) {
      id = dataList[data.selectedIndex]?.id
    }

    handleCallService({
      data: {
        id: id,
        value: data.expectedWay,
      },
    })
  }

  const onDelete = (index) => {
    let dataList = [...formSchema.value]
    handleDelete(dataList[index])
  }

  console.log('formSchema => ', formSchema)
  return (
    <>
      <b>{formSchema.header}</b>

      {isEdit && showCommandButton ? (
        <InputDataTableForm
          key="key-result"
          schema={formSchema}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          onSubmit={handleSubmit(onSubmit)}
          onDelete={onDelete}
          isError={isError}
          isDeleteError={isDeleteError}
          loading={isLoading}
        />
      ) : (
        <InputDataTableView schema={formSchema} />
      )}
    </>
  )
}
